<template>
	<div class="skeleton-lines p-5">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
	<div class="columns">
		<div class="column p-5">
			<div class="skeleton-block"></div>
		</div>
		<div class="column p-5">
			<div class="skeleton-lines">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({

})
</script>

<style scoped>

</style>
